import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box, Text, VStack } from '@chakra-ui/react';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { formLabelStyling, stackStyling, descriptionStyling } from 'components/forms/new/formStyles';
import { Field } from 'formik';
import NameField from 'components/forms/new/formikFormFields/NameField';



const NumberBlockRateField = ({ errors, touched, darkMode, name = 'rate' }) => {
    const [isHovered, setIsHovered] = useState(false);
    const error = errors[name];
    const showError = touched[name];
    return (
        <FormControl sx={{ margin: '24px 0 24px 0 !important', width: '100%' }} isInvalid={!!error && showError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Stack direction="row" sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Rate <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Enter the rate for this number block.
                    </Text>
                </Box>
                <Box flex="1" minWidth="250px"  sx={{
                                                                                display: 'flex',
                                                                                alignItems: 'flex-start',
                                                                               marginTop: '24px',
                                                                            }}>
                     
                    <VStack width="100%" alignItems="normal">
                        <Field
                            as={NameField}
                            id="rate"
                            name="rate"
                            error={errors.rate}
                            type="number"
                            step="any"
                        />
                        {showError && (
                            <Text color="red.500" fontSize="xs" mt={1} textAlign="right">
                                {error}
                            </Text>
                        )}
                    </VStack>
                 
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Enter the rate."
                        ariaLabel="number-block-rate-tip"
                        left="25px"
                        top="25px   "
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default NumberBlockRateField;
